import { formatEnumName, formatEnumValue } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const addEnumValueStmtInstruction = `
#### Add enum values
- Syntax: \`alter enum <enum_name> add <value1>[, <value2>]';\`
- Example: \`alter enum orderStatus add postponed, returned;\``;
export const stmtAddEnumValue = ({ enumName, values }) => {
    return `alter enum ${enumName} add ${values.join(', ')};`;
};
export const stmtForHumanAddEnumValue = ({ enumName, values }) => {
    return `Add the values __${values.join(', ')}__ to the enum __${enumName}__.`;
};
export const addEnumValueHandler = createSchemaStatementHandler({
    type: 'add enum value',
    parse: line => {
        const match = /^alter enum (?<enumName>[\w_]+) add (?<values>[\w, ]+)/.exec(line);
        return match?.groups
            ? {
                type: 'add enum value',
                enumName: formatEnumName(match.groups.enumName),
                values: match.groups.values.split(', ').map(value => formatEnumValue(value)),
            }
            : null;
    },
    getHumanStmt: stmtForHumanAddEnumValue,
    apply: (stmt, builder) => {
        builder.updateSchema(it => {
            if (!it.schema.model.enums[stmt.enumName]) {
                return it.addEnum(stmt);
            }
            return it.updateEnumValues(stmt.enumName, it => Array.from(new Set([...it, ...stmt.values])));
        });
    },
});
//# sourceMappingURL=AddEnumValueStmt.js.map